import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import { faqItems } from '@/mocks/content';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-16 bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <Reveal>
              <SectionHeading
                eyebrow="FAQ"
                title="读者常见问题"
                desc="关于资源形式、阅读方式与版本差异，是读者最常提出的疑问。下面集中整理了这些问题的解答，点击即可展开查看。"
              />
            </Reveal>
            <Reveal delay={80}>
              <div className="mt-8 rounded-lg bg-background-100 border border-background-200 p-5 flex items-start gap-3">
                <i className="ri-lightbulb-flash-line text-2xl text-primary-600" />
                <p className="text-sm leading-relaxed text-foreground-600">
                  如果上面的问题没有覆盖到你的情况，可以先参考「阅读贴士」分区，那里补充了更多实际操作层面的建议。
                </p>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            <div className="flex flex-col gap-3">
              {faqItems.map((item, index) => {
                const isOpen = open === index;
                return (
                  <Reveal key={item.q} delay={index * 40}>
                    <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
                      <button
                        type="button"
                        onClick={() => setOpen(isOpen ? null : index)}
                        aria-expanded={isOpen}
                        className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
                      >
                        <span className="font-heading text-sm md:text-base font-semibold text-foreground-900">
                          {item.q}
                        </span>
                        <i
                          className={`text-xl text-primary-600 shrink-0 transition-transform duration-300 ${
                            isOpen ? 'ri-subtract-line' : 'ri-add-line'
                          }`}
                        />
                      </button>
                      <div
                        className={`px-5 overflow-hidden transition-all duration-300 ${
                          isOpen ? 'max-h-96 py-0 pb-5 opacity-100' : 'max-h-0 opacity-0'
                        }`}
                      >
                        <p className="text-sm leading-relaxed text-foreground-600 border-t border-background-200 pt-4">
                          {item.a}
                        </p>
                      </div>
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}